import * as React from 'react'
import { connect } from 'react-redux'

import * as Yup from 'yup'
import { Form, Formik, FormikProps } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Label, Modal, Button, FormGroup, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import { ClaimInvoice } from 'src/lib/interfaces/ClaimInvoice.interface'

import * as invoicesActions from '../../../store/invoices/actions'

const moment = require('moment')

interface FormValues {
  mailTracking?: string  
}

interface InvoiceTrackingModalProps {
  open?: boolean
  onClose: () => void
  invoiceId: string|number
  addTracking: (invoiceId: string, mailTracking: string, next?: (err?: any, invoice?: ClaimInvoice) => void) => void
}

interface InvoiceTrackingModalState {
  isLoading: boolean
}

class InvoiceTrackingModal extends React.Component<InvoiceTrackingModalProps> {
  state = {
    isLoading: false
  }

  get validationSchema() {
    return Yup.object().shape({
      mailTracking: Yup.string().required()      
    })
  }

  handleSubmit(values) {
    const { invoiceId, addTracking } = this.props

    this.setState({ isLoading: true }, () => {
      addTracking(invoiceId as string, values.mailTracking, (err?: any, invoice?: ClaimInvoice) => {
        
        if (!err) {
          this.setState({ isLoading: false}, this.props.onClose)
        }
      })
    })
  }

  render() {
    const { isLoading } = this.state
    const { open, onClose } = this.props

    return (
      <Modal isOpen={open} toggle={onClose}>
        <Formik
          initialValues={{}}
          validationSchema={this.validationSchema}
          onSubmit={values => this.handleSubmit(values)}
          render={(props: FormikProps<FormValues>) => (
            <Form>
              <ModalHeader toggle={onClose}>Add Tracking Number</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label className="font-weight-bold text-secondary">Tracking Number</Label>
                  <Input
                    name="mailTracking"
                    onChange={props.handleChange}
                    value={props.values.mailTracking}
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="light" onClick={onClose} disabled={isLoading}>Cancel</Button>
                <Button type="submit" color="primary" disabled={isLoading || !props.isValid}>
                  {isLoading &&
                    <FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
                  }
                  Add
                </Button>
              </ModalFooter>
            </Form>
          )}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({  
  addTracking: (invoiceId: string, mailTracking: string, next?: (err?: any, invoice?: ClaimInvoice) => void) => dispatch(invoicesActions.addInvoiceTracking(invoiceId, mailTracking, next))  
})

export default connect(null, mapDispatchToProps)(InvoiceTrackingModal)



// WEBPACK FOOTER //
// ./src/routes/invoices/components/InvoiceTracking.modal.tsx